// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Card$Showside from "./Card.bs.js";
import * as CTABar$Showside from "./CTABar.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as ProductPrice$Showside from "./ProductPrice.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as StoreProvider$Showside from "../context/StoreProvider.bs.js";
import * as ProductReviews$Showside from "./ProductReviews.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as PDPContentDetailsCard$Showside from "./PDPContentDetailsCard.bs.js";
function PDPContentHeader(Props) {
  var product = Props.product;
  var variant = Props.variant;
  var scrollToDetails = Props.scrollToDetails;
  var positionOpt = Props.position;
  var animateVisibilityOpt = Props.animateVisibility;
  var shadowOpt = Props.shadow;
  var bgOpt = Props.bg;
  var imageOpt = Props.image;
  var showCTAOpt = Props.showCTA;
  var reviewsOpt = Props.reviews;
  var allowTitleWrapOpt = Props.allowTitleWrap;
  var productCategory = Props.productCategory;
  var productPositionOpt = Props.productPosition;
  var productsCountOpt = Props.productsCount;
  var maxWidth = Props.maxWidth;
  var sizeOpt = Props.size;
  var variantsInfoOpt = Props.variantsInfo;
  var variantsOpt = Props.variants;
  var optionSize = Props.optionSize;
  var optionStyle = Props.optionStyle;
  var colorOptionSize = Props.colorOptionSize;
  var titleStyle = Props.titleStyle;
  var largeTitleStyle = Props.largeTitleStyle;
  var titleSize = Props.titleSize;
  var onBackClick = Props.onBackClick;
  var position = positionOpt !== undefined ? positionOpt : /* Relative */0;
  var animateVisibility = animateVisibilityOpt !== undefined ? animateVisibilityOpt : false;
  var shadow = shadowOpt !== undefined ? shadowOpt : true;
  var bg = bgOpt !== undefined ? bgOpt : true;
  var image = imageOpt !== undefined ? imageOpt : true;
  var showCTA = showCTAOpt !== undefined ? showCTAOpt : false;
  var reviews = reviewsOpt !== undefined ? reviewsOpt : false;
  var allowTitleWrap = allowTitleWrapOpt !== undefined ? allowTitleWrapOpt : false;
  var productPosition = productPositionOpt !== undefined ? productPositionOpt : 0;
  var productsCount = productsCountOpt !== undefined ? productsCountOpt : 0;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var variantsInfo = variantsInfoOpt !== undefined ? variantsInfoOpt : false;
  var variants = variantsOpt !== undefined ? variantsOpt : false;
  var store = StoreProvider$Showside.use(undefined);
  var match = RouterProvider$Showside.useRouter(undefined);
  var goTo = match.goTo;
  var match$1 = React.useState(function () {
    return false;
  });
  var setHover = match$1[1];
  var match$2 = ViewportContext$Showside.use(undefined);
  var match$3 = ConfigurationProvider$Showside.use(undefined);
  var scrollToDetailsRef = React.useRef(scrollToDetails);
  var size$1 = Belt_Option.isSome(productCategory) ? /* Lg */1 : size;
  var stickyHeight = size$1 ? 110 : 110 - 3;
  var tmp;
  switch (position) {
    case /* Relative */0:
      tmp = "relative";
      break;
    case /* StickyTop */1:
      tmp = "sticky top-0";
      break;
    case /* FixedBottom */2:
      tmp = "fixed bottom-0";
      break;
    case /* FixedTop */3:
      tmp = "fixed top-0";
      break;
  }
  var tmp$1;
  var exit = 0;
  if (position !== 1 && position < 3) {
    tmp$1 = "";
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp$1 = match$2.windowSize.width <= 1600 && match$2.breakpoint > /* Sm */1 ? "pt-18" : "";
  }
  var tmp$2 = {};
  var tmp$3 = animateVisibility && position === 2 ? String(stickyHeight) + "px" : undefined;
  if (tmp$3 !== undefined) {
    tmp$2.marginTop = tmp$3;
  }
  if (maxWidth !== undefined) {
    tmp$2.maxWidth = maxWidth;
  }
  var tmp$4 = {
    className: CSS$Showside.prefix(Cn.make([tmp, "w-full bg-main z-20", maxWidth !== undefined ? "left-1/2 -translate-x-1/2" : "left-0", "p-6 pl-3", tmp$1, shadow && position !== 0 ? "shadow" : "", "transition-transform transform", animateVisibility ? position !== 1 ? "translate-y-0" : "translate-y-full" : position !== 2 ? position >= 3 ? "-translate-y-full" : "translate-y-0" : "translate-y-full"])),
    style: tmp$2,
    onMouseEnter: function (param) {
      Curry._1(setHover, function (param) {
        return true;
      });
    },
    onMouseLeave: function (param) {
      Curry._1(setHover, function (param) {
        return false;
      });
    }
  };
  var tmp$5 = animateVisibility ? undefined : true;
  if (tmp$5 !== undefined) {
    tmp$4["aria-hidden"] = Caml_option.valFromOption(tmp$5);
  }
  var match$4 = variant.media;
  var tmp$6;
  var exit$1 = 0;
  var url;
  if (image) {
    switch (match$4.TAG | 0) {
      case /* Image */0:
        url = match$4._0.url;
        exit$1 = 1;
        break;
      case /* Video */1:
        var url$1 = match$4._0.posterUrl;
        if (url$1 !== undefined) {
          url = url$1;
          exit$1 = 1;
        } else {
          tmp$6 = null;
        }
        break;
      case /* IframeEmbed */2:
        tmp$6 = null;
        break;
    }
  } else {
    tmp$6 = null;
  }
  if (exit$1 === 1) {
    var maxHeight = stickyHeight - (size$1 ? 24 : 38);
    var ratio = Card$Showside.Size.getRatio(match$3.config.settings.productCardShape);
    var width = maxHeight * ratio;
    tmp$6 = React.createElement("div", {
      className: CSS$Showside.prefix("flex items-center justify-center flex-shrink-0 flex-grow-0"),
      tabIndex: 0,
      onClick: function (e) {
        if (onBackClick !== undefined) {
          return Curry._1(onBackClick, e);
        } else {
          return Curry._1(scrollToDetails, undefined);
        }
      }
    }, onBackClick !== undefined ? React.createElement(Unicons$Showside.UilAngleLeftB.make, {
      size: /* Px */{
        _0: 20
      }
    }) : null, React.createElement("div", {
      className: CSS$Showside.prefix("relative"),
      style: {
        height: String(maxHeight) + "px",
        width: String(width) + "px"
      }
    }, React.createElement(SmartImg$Showside.make, {
      src: url,
      fit: /* Cover */1,
      priority: 0,
      noFlicker: true
    })));
  }
  var tmp$7 = {};
  var tmp$8 = allowTitleWrap ? "72px" : undefined;
  if (tmp$8 !== undefined) {
    tmp$7.minHeight = tmp$8;
  }
  var match$5 = product.reviewSummary;
  var tmp$9 = {
    product: product,
    variant: variant,
    secondary: false,
    tertiary: false
  };
  var tmp$10 = animateVisibility ? undefined : -1;
  if (tmp$10 !== undefined) {
    tmp$9.tabIndex = Caml_option.valFromOption(tmp$10);
  }
  var tmp$11 = {
    product: product,
    variant: variant,
    scrollToDetailsRef: scrollToDetailsRef,
    showHeader: false,
    layout: /* Inline */2,
    sections: ["variants", "quantity", "cta"],
    showSizeGuide: false
  };
  if (productCategory !== undefined) {
    tmp$11.productCategory = Caml_option.valFromOption(productCategory);
  }
  if (titleStyle !== undefined) {
    tmp$11.titleStyle = Caml_option.valFromOption(titleStyle);
  }
  if (largeTitleStyle !== undefined) {
    tmp$11.largeTitleStyle = Caml_option.valFromOption(largeTitleStyle);
  }
  if (titleSize !== undefined) {
    tmp$11.titleSize = Caml_option.valFromOption(titleSize);
  }
  if (optionSize !== undefined) {
    tmp$11.optionSize = Caml_option.valFromOption(optionSize);
  }
  if (optionStyle !== undefined) {
    tmp$11.optionStyle = Caml_option.valFromOption(optionStyle);
  }
  if (colorOptionSize !== undefined) {
    tmp$11.colorOptionSize = Caml_option.valFromOption(colorOptionSize);
  }
  var tmp$12 = animateVisibility ? undefined : -1;
  if (tmp$12 !== undefined) {
    tmp$11.tabIndex = Caml_option.valFromOption(tmp$12);
  }
  return React.createElement("div", tmp$4, bg ? React.createElement("div", {
    className: CSS$Showside.prefix("absolute inset-0 bg-gray-600 opacity-20 z-0")
  }) : null, React.createElement("div", {
    className: CSS$Showside.prefix("relative z-10 flex items-start justify-between space-x-4")
  }, tmp$6, React.createElement("div", {
    className: CSS$Showside.prefix("leading-loose flex flex-col gap-2 flex-grow-1 w-full"),
    style: tmp$7,
    onClick: function (param) {
      Curry._1(scrollToDetails, undefined);
    }
  }, productCategory !== undefined ? React.createElement("div", {
    className: CSS$Showside.prefix("flex gap-5 items-end justify-start text-lg")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("uppercase font-semibold underline cursor-pointer"),
    onClick: function (param) {
      Curry._3(goTo, undefined, undefined, {
        TAG: /* ListPage */1,
        _0: {
          listPageType: {
            TAG: /* Category */0,
            _0: productCategory.id
          },
          viewPLP: false,
          filters: undefined,
          sort: undefined
        }
      });
    }
  }, productCategory.title), React.createElement("div", undefined, String(productPosition + 1 | 0) + "/" + String(productsCount))) : null, React.createElement(DataAttribute$Showside.make, {
    dataTestId: "pdp-product-title",
    children: React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["truncate-lines font-bold", allowTitleWrap ? "truncate-lines-2" : "truncate-lines-1", size$1 ? "text-2xl" : "text-xl"]))
    }, Product$Showside.getDisplayName(store, variant, product))
  }), React.createElement("div", {
    className: CSS$Showside.prefix("flex gap-6 items-center justify-start mt-2")
  }, React.createElement(ProductPrice$Showside.make, {
    at: /* PDP */0,
    product: product,
    variant: variant,
    size: size$1 ? /* Md */1 : /* Sm */2,
    marginTop: false,
    minPriceFirst: true,
    multiline: false,
    bold: false
  })), reviews && match$5 !== undefined ? React.createElement(ProductReviews$Showside.make, {
    at: /* PDP */0,
    product: product,
    variant: variant,
    countClassName: CSS$Showside.prefix("text-base text-secondary")
  }) : null, variantsInfo ? Belt_Array.joinWith(Belt_Array.keep([["colors", Product$Showside.getOptionsByName(product, "Color").length], ["sizes", Product$Showside.getOptionsByName(product, "Size").length]], function (param) {
    return param[1] > 1;
  }), ", ", function (param) {
    return String(param[1]) + " " + param[0];
  }) : null), React.createElement(ConditionalRender$Showside.When.make, {
    condition: showCTA,
    children: React.createElement("div", {
      className: CSS$Showside.prefix("flex-shrink-0")
    }, React.createElement(CTABar$Showside.make, tmp$9))
  }), React.createElement(ConditionalRender$Showside.When.make, {
    condition: variants,
    children: React.createElement(PDPContentDetailsCard$Showside.make, tmp$11)
  })));
}
PDPContentHeader.displayName = "PDPContentHeader";
var stickyHeight = 110;
var make = PDPContentHeader;
export { stickyHeight, make };
/* react Not a pure module */